export default {
  title: 'Hizmetlerimiz',
  consulting: {
    title: 'Danışmanlık',
    description: 'Gayrimenkul piyasasında karar verme sürecinde profesyonel yardım.',
    more: 'Daha fazla bilgi',
  },
  ai_valuation: {
    title: 'Yapay Zeka ile Değerleme',
    description: 'Algoritmalar kullanarak anında gayrimenkul değerleme.',
    more: 'Daha fazla bilgi edinin',
  },
  market_analytics: {
    title: 'Pazar Analizi',
    description: 'Gayrimenkul piyasasının durumu ve trendleri hakkında düzenli raporlar.',
    more: 'Oku',
  },
  data_security: {
    title: 'Veri Güvenliği',
    description: 'Bilgilerinizin saklanması ve işlenmesi için modern yöntemler.',
    more: 'Daha fazla bilgi',
  },
  automation: {
    title: 'Otomasyon',
    description: 'Süreç otomasyonu ile manuel çalışmayı azaltma.',
    more: 'Göster',
  },
  internet_solutions: {
    title: 'İnternet Çözümleri',
    description: 'Akıllı evler için dijital hizmetler ve IoT entegrasyonu.',
    more: 'Öğren',
  }
}
